import classNames from 'classnames'
import {ArrowRightSmIcon, BookIcon, EmailIcon, RenderIf} from 'components/Basic'
import {colorCodes, emailSupport, helpDocs} from 'definitions/constant'
import {FC} from 'react'

const inflightDocsDopeSecurity = 'https://inflight.dope.security'
const dopeSupportEmail = 'mailto:support@dope.security'

const helpSectionArray: {title: string; value: string}[] = [
  {
    title: 'Email Support',
    value: dopeSupportEmail,
  },
  {
    title: 'Help Docs',
    value: inflightDocsDopeSecurity,
  },
]

interface HelpSectionProps {
  isTopBarToBeBlueColor: boolean
}

const HelpSection: FC<HelpSectionProps> = ({isTopBarToBeBlueColor}) => {
  return (
    <div
      id="help-section"
      className={classNames(
        'border-l-0.5 border-b-0.5 border-r-0.5 border-gray-400 z-50 absolute right-16 w-56',
        {
          'bg-dope-black': !isTopBarToBeBlueColor,
          'bg-dope-teal-100': isTopBarToBeBlueColor,
        },
      )}
    >
      {helpSectionArray.map(({title, value}) => {
        const uniqueKey = `help-${title}`
        return (
          <a
            href={value}
            target="_blank"
            className={classNames(
              'py-4 px-6 flex flex-row justify-between items-center border-b-1 h-8 border-gray-1200 cursor-pointer',
              {
                'hover:bg-gray-800': !isTopBarToBeBlueColor,
                'hover:bg-dope-teal-300': isTopBarToBeBlueColor,
              },
            )}
            data-cy={uniqueKey}
            key={uniqueKey}
          >
            <div className="flex flex-row items-center gap-2">
              <RenderIf isTrue={title === emailSupport}>
                <EmailIcon
                  width={12}
                  height={12}
                  strokeColor={colorCodes.white}
                  strokeWidth={50}
                />
              </RenderIf>
              <RenderIf isTrue={title === helpDocs}>
                <BookIcon
                  width={14}
                  height={14}
                  strokeColor={colorCodes.white}
                  strokeWidth={1}
                  classes="-ml-0.5"
                />
              </RenderIf>
              <p className="karla text-xs w-32 text-white underline decoration-0">
                {title}
              </p>
            </div>
            <ArrowRightSmIcon classes="cursor-pointer" />
          </a>
        )
      })}
    </div>
  )
}

export default HelpSection
